<template>
	<div>
		<a-form-model ref="addForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"  :model="theObj" :rules="rules">
			<a-form-model-item label="开始日期"  prop="begindate">
				<a-select  style="width:20rem;" v-model="theObj.begindate" placeholder="请选择开始日期" >
					<a-select-option v-for="i in 31" :key="i" :disabled="i>theObj.enddate">{{i}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="结束日期"  prop="enddate">
				<a-select style="width:20rem;" v-model="theObj.enddate" placeholder="请选择结束日期" >
					<a-select-option v-for="i in 31" :key="i" :disabled="i<theObj.begindate">{{i}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="执行时间"  prop="time">
				<a-select style="width:20rem;" v-model="theObj.time" placeholder="请选择执行时间" >
					<a-select-option v-for="i in 24" :key="i">{{i}}点</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="阈值"  prop="threshold">
				<a-input-number v-model="theObj.threshold" placeholder="请填写阈值" :min="0" :precision="2" style="width:20rem;"/>
			</a-form-model-item>
			<a-form-model-item label="是否执行">
				<a-switch default-checked  @change="changeState" checked-children="执行" un-checked-children="不执行"/>
			</a-form-model-item>
			<a-form-model-item label="扫描类型">
				<a-select style="width:20rem;" v-model="theObj.prepay">
					<a-select-option value="0">全部</a-select-option>
					<a-select-option value="1">预付费</a-select-option>
					<a-select-option value="2">后付费</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="短信发送方式">
				<a-select style="width:20rem;" v-model="theObj.model" >
					<a-select-option value="1">自动</a-select-option>
					<a-select-option value="2">手动</a-select-option>
				</a-select>
			</a-form-model-item>
		</a-form-model>
		<a-table size="small" :columns="columns" :data-source="neighborList" bordered   rowKey="pId" :pagination="false"
					  style="margin-top: 1.25rem;" :scroll="{y:300}" :row-selection="rowSelectHandler">
		</a-table>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	const columns = [
		{
			title: '小区名称',
			dataIndex: 'neighborName',
			ellipsis :true,
		},
	];
	export default{
		data(){
			return{
				columns,
				submitFlag:false,
				theObj:{
					begindate:undefined,
					enddate:undefined,
					time:undefined,
					threshold:null,
					state:'1',
					prepay:'0',
					model:'1',
				},
				neighborList:[],
				selectedList:[],
				rules:{
					begindate:[{required:true,message:'请选择开始日期',trigger: 'change'}],
					enddate:[{required:true,message:'请选择结束日期',trigger: 'change'}],
					time:[{required:true,message:'请选择执行时间',trigger: 'change'}],
					threshold:[{required:true,message:'请填写阈值',trigger: 'blur'}],
				},
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						if(this.selectedList.length == 0){
							this.$message.error('请选择小区信息');
						}else{
							this.doSubmit();
						}
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_ADD_URL);
				this.theObj.neighborIds = this.getNeighborIds();
				this.theObj.neighborNames = this.getNeighborNames();
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('新增扫描任务成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				});
			},
			changeState:function(checked,e){
				this.theObj.state = checked?'1':'2';
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NEIGHBORS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getNeighborIds:function(){
					let temp = [];
					for(var i = 0;i<this.selectedList.length;i++){
						let item = this.selectedList[i];
						temp.push(item.pId);
					}
					return temp.join(',');
			},
			getNeighborNames:function(){
					let temp = [];
					for(var i = 0;i<this.selectedList.length;i++){
						let item = this.selectedList[i];
						temp.push(item.neighborName);
					}
					return temp.join(',');
			},
		},
		created() {
			this.queryNeighbors();
		},
		computed:{
			rowSelectHandler:function(){
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						this.selectedList = selectedRows;
					},
				}
			}
		}
	}
</script>

<style>
</style>
